<template>
    <div class="app-hub-page dispatch-center">
        <h1 class="app-hub-page-title">外派订单</h1>
        <el-card class="dispatch-center__shell app-hub-card" shadow="never">
            <el-tabs v-model="activeTab" class="dispatch-center__tabs app-hub-tabs" type="border-card">
                <el-tab-pane label="外派订单" name="orders">
                    <div class="dispatch-center__pane app-hub-pane">
                        <el-row :gutter="12" class="dispatch-center__stats app-hub-stats">
                            <el-col :xs="12" :sm="6">
                                <div class="app-hub-stat">
                                    <div class="app-hub-stat__label">订单总数</div>
                                    <div class="app-hub-stat__value">{{ orderStats.order_count }}</div>
                                </div>
                            </el-col>
                            <el-col :xs="12" :sm="6">
                                <div class="app-hub-stat app-hub-stat--muted">
                                    <div class="app-hub-stat__label">{{ dispatchStatPayableSumLabel }}</div>
                                    <div class="app-hub-stat__value">¥ {{ formatMoney(orderStats.dispatch_payable_sum) }}</div>
                                </div>
                            </el-col>
                            <el-col :xs="12" :sm="6">
                                <div class="app-hub-stat app-hub-stat--muted">
                                    <div class="app-hub-stat__label">{{ dispatchStatPaidSumLabel }}</div>
                                    <div class="app-hub-stat__value">¥ {{ formatMoney(orderStats.dispatch_paid_sum) }}</div>
                                </div>
                            </el-col>
                            <el-col :xs="12" :sm="6">
                                <div class="app-hub-stat app-hub-stat--accent">
                                    <div class="app-hub-stat__label">{{ dispatchStatPendingSumLabel }}</div>
                                    <div class="app-hub-stat__value">¥ {{ formatMoney(orderStats.dispatch_pending_sum) }}</div>
                                </div>
                            </el-col>
                        </el-row>

                        <el-form :inline="true" size="small" class="dispatch-center__filters app-hub-filters" @submit.native.prevent="runOrderSearch">
                            <div class="dispatch-center__filters-left app-hub-filters__left">
                                <el-form-item :label="isDispatchTaxOnlySubaccount ? '' : '综合'">
                                    <el-input
                                        v-model.trim="orderFilters.keyword"
                                        clearable
                                        placeholder="公司名称、信用机构代码证搜索"
                                        class="dispatch-center__filter-input--wide app-search-input"
                                        @keyup.enter.native="runOrderSearch"
                                    />
                                </el-form-item>
                                <el-form-item v-if="showDispatchReceiverFilter" label="外派员">
                                    <el-select
                                        v-model="orderFilters.receiver_user_id"
                                        clearable
                                        filterable
                                        placeholder="全部"
                                        class="dispatch-center__filter-select"
                                    >
                                        <el-option
                                            v-for="u in receiverOptions"
                                            :key="u.id"
                                            :label="receiverOptionLabel(u)"
                                            :value="u.id"
                                        />
                                    </el-select>
                                </el-form-item>
                                <el-form-item v-if="isDispatchBizOrBothSubaccount" label="结算">
                                    <el-select
                                        v-model="orderFilters.settlement_status"
                                        clearable
                                        placeholder="全部"
                                        class="dispatch-center__filter-select--narrow"
                                    >
                                        <el-option label="未结清" value="unsettled" />
                                        <el-option label="已结清" value="settled" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item v-else-if="isDispatchSuperAdmin" label="结算">
                                    <el-select
                                        v-model="orderFilters.settlement_status"
                                        clearable
                                        placeholder="全部"
                                        class="dispatch-center__filter-select--narrow"
                                    >
                                        <el-option label="已结清" value="settled" />
                                        <el-option label="未结清" value="unsettled" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item v-else-if="!isDispatchTaxOnlySubaccount" label="归档模块">
                                    <el-select
                                        v-model="orderFilters.is_archived"
                                        clearable
                                        placeholder="全部"
                                        class="dispatch-center__filter-select--narrow"
                                    >
                                        <el-option label="未归档" :value="0" />
                                        <el-option label="已归档" :value="1" />
                                    </el-select>
                                </el-form-item>
                                <div
                                    v-if="isDispatchTaxOnlySubaccount"
                                    class="dispatch-center__filters-actions-inline"
                                >
                                    <el-button type="primary" @click="runOrderSearch">查询</el-button>
                                    <el-button @click="resetOrderFilters">重置</el-button>
                                </div>
                            </div>
                            <div class="dispatch-center__filters-right app-hub-filters__right">
                                <div
                                    v-if="isDispatchTaxOnlySubaccount"
                                    class="dispatch-center__export-inline"
                                >
                                    <el-date-picker
                                        v-model="exportDateRange"
                                        type="daterange"
                                        unlink-panels
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        value-format="yyyy-MM-dd"
                                        class="dispatch-center__export-date"
                                    />
                                    <el-button
                                        type="primary"
                                        icon="el-icon-download"
                                        :loading="exportLoading"
                                        @click="exportTaxOnlyOrders"
                                    >
                                        导出
                                    </el-button>
                                </div>
                                <el-form-item
                                    v-if="!isDispatchTaxOnlySubaccount"
                                    class="dispatch-center__filters-actions app-hub-filters__actions"
                                >
                                    <el-button type="primary" @click="runOrderSearch">查询</el-button>
                                    <el-button @click="resetOrderFilters">重置</el-button>
                                </el-form-item>
                            </div>
                        </el-form>

                        <el-table
                            v-loading="ordersLoading"
                            :data="pagedOrders"
                            border
                            stripe
                            size="small"
                            class="dispatch-center__table app-hub-table"
                            :header-cell-style="{ textAlign: 'center' }"
                            :cell-style="{ textAlign: 'center' }"
                        >
                            <template v-if="isDispatchTaxOnlySubaccount">
                                <el-table-column label="日期" min-width="90" align="center" header-align="center" show-overflow-tooltip>
                                    <template slot-scope="{ row }">{{ formatOrderDate(row) }}</template>
                                </el-table-column>
                                <el-table-column label="公司名称" min-width="240" align="center" header-align="center" show-overflow-tooltip>
                                    <template slot-scope="{ row }">{{ row.company && row.company.name ? row.company.name : '—' }}</template>
                                </el-table-column>
                                <el-table-column label="统一信用代码" min-width="170" align="center" header-align="center" show-overflow-tooltip>
                                    <template slot-scope="{ row }">{{ row.company && row.company.credit_code ? row.company.credit_code : '—' }}</template>
                                </el-table-column>
                                <el-table-column label="姓名" min-width="80" align="center" header-align="center" show-overflow-tooltip>
                                    <template slot-scope="{ row }">{{ row.company && row.company.legal_name ? row.company.legal_name : '—' }}</template>
                                </el-table-column>
                                <el-table-column label="法人身份证" min-width="170" align="center" header-align="center" show-overflow-tooltip>
                                    <template slot-scope="{ row }">{{ row.company && row.company.legal_id_no ? row.company.legal_id_no : '—' }}</template>
                                </el-table-column>
                                <el-table-column label="法人手机号" min-width="120" align="center" header-align="center" show-overflow-tooltip>
                                    <template slot-scope="{ row }">{{ row.company && row.company.phone ? row.company.phone : '—' }}</template>
                                </el-table-column>
                                <el-table-column label="税务进度" min-width="95" align="center" header-align="center" show-overflow-tooltip>
                                    <template slot-scope="{ row }">{{ formatTaxProgressLabel(row) }}</template>
                                </el-table-column>
                            </template>
                            <template v-else>
                                <el-table-column label="日期" width="85" align="center" header-align="center" show-overflow-tooltip>
                                    <template slot-scope="{ row }">{{ formatOrderDate(row) }}</template>
                                </el-table-column>
                                <el-table-column
                                    label="公司名称"
                                    :width="isDispatchSubaccount ? 250 : 245"
                                    align="center"
                                    header-align="center"
                                    show-overflow-tooltip
                                >
                                    <template slot-scope="{ row }">{{ row.company && row.company.name ? row.company.name : '—' }}</template>
                                </el-table-column>
                                <el-table-column label="统一信用代码" width="160" align="center" header-align="center" show-overflow-tooltip>
                                    <template slot-scope="{ row }">{{ row.company && row.company.credit_code ? row.company.credit_code : '—' }}</template>
                                </el-table-column>
                                <el-table-column label="外派员" width="90" align="center" header-align="center" show-overflow-tooltip>
                                    <template slot-scope="{ row }">{{ dispatchReceiverName(row) }}</template>
                                </el-table-column>
                                <el-table-column
                                    label="外派员手机号"
                                    width="105"
                                    align="center"
                                    header-align="center"
                                    class-name="dispatch-center__td-phone"
                                    :show-overflow-tooltip="false"
                                >
                                    <template slot-scope="{ row }">
                                        <span class="dispatch-center__phone-text">{{ dispatchReceiverPhone(row) }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="税务进度" width="90" align="center" header-align="center" show-overflow-tooltip>
                                    <template slot-scope="{ row }">{{ formatTaxProgressLabel(row) }}</template>
                                </el-table-column>
                                <el-table-column label="工商进度" width="90" align="center" header-align="center" show-overflow-tooltip>
                                    <template slot-scope="{ row }">{{ formatBizProgressLabel(row) }}</template>
                                </el-table-column>
                                <el-table-column :label="dispatchAmountPayableColLabel" width="90" align="center" header-align="center" show-overflow-tooltip>
                                    <template slot-scope="{ row }">¥ {{ dispatchFee(row, 'payable') }}</template>
                                </el-table-column>
                                <el-table-column :label="dispatchAmountPaidColLabel" width="90" align="center" header-align="center" show-overflow-tooltip>
                                    <template slot-scope="{ row }">¥ {{ dispatchFee(row, 'paid') }}</template>
                                </el-table-column>
                                <el-table-column :label="dispatchAmountPendingColLabel" width="90" align="center" header-align="center" show-overflow-tooltip>
                                    <template slot-scope="{ row }">¥ {{ dispatchFee(row, 'pending') }}</template>
                                </el-table-column>
                                <el-table-column
                                    label="操作"
                                    :width="isDispatchSubaccount ? 123 : 133"
                                    align="center"
                                    header-align="center"
                                >
                                    <template slot-scope="{ row }">
                                        <template v-if="isDispatchSubaccount">
                                            <el-button
                                                v-if="isDispatchBizOrBothSubaccount"
                                                type="text"
                                                size="small"
                                                :class="dispatchConfirmActionClass(row)"
                                                :disabled="!canConfirmDispatchCollection(row) || actionSubmittingId === row.id"
                                                @click="confirmDispatchReceipt(row)"
                                            >
                                                确认收款
                                            </el-button>
                                            <el-button
                                                v-if="isDispatchBizOrBothSubaccount"
                                                type="text"
                                                size="small"
                                                :disabled="!canRemindDispatchCollection(row) || actionSubmittingId === row.id"
                                                @click="remindDispatchCollection(row)"
                                            >
                                                催款
                                            </el-button>
                                            <el-button
                                                v-if="showDispatchOrderDelete && !isDispatchBizOrBothSubaccount"
                                                type="text"
                                                size="small"
                                                class="dispatch-center__delete"
                                                :disabled="isDispatchBizOrBothSubaccount"
                                                @click="confirmDeleteOrder(row)"
                                            >
                                                删除
                                            </el-button>
                                        </template>
                                        <template v-else>
                                            <el-button
                                                type="text"
                                                size="small"
                                                :class="dispatchFeeActionClass(row)"
                                                :disabled="isDispatchFeeLocked(row)"
                                                @click="openDispatchFee(row)"
                                            >
                                                费用登记
                                            </el-button>
                                            <el-button
                                                v-if="showDispatchOrderDelete"
                                                type="text"
                                                size="small"
                                                class="dispatch-center__delete"
                                                @click="confirmDeleteOrder(row)"
                                            >
                                                删除
                                            </el-button>
                                        </template>
                                    </template>
                                </el-table-column>
                            </template>
                        </el-table>

                        <div v-if="shouldShowPager" class="dispatch-center__pager app-hub-pager app-pagination-antd-wrap">
                            <el-pagination
                                background
                                layout="total, prev, pager, next, sizes"
                                popper-class="app-pagination-antd-sizes-popper"
                                :page-sizes="[10, 20, 50, 100]"
                                :current-page="orderPage"
                                :page-size="orderPerPage"
                                :total="filteredOrders.length"
                                @current-change="handleOrderPageChange"
                                @size-change="handleOrderPageSizeChange"
                            />
                        </div>
                    </div>
                </el-tab-pane>

                <el-tab-pane label="外派管理" name="manage" lazy>
                    <div class="dispatch-center__pane app-hub-pane">
                        <settings-dispatch-receivers />
                    </div>
                </el-tab-pane>
            </el-tabs>
        </el-card>
        <el-dialog
            title="外派费用登记"
            :visible.sync="feeDialogVisible"
            width="480px"
            append-to-body
            @closed="resetFeeForm"
        >
            <el-form label-width="100px" size="small">
                <el-form-item :label="dispatchFeeDialogPayableLabel">
                    <el-input-number
                        v-model="feeForm.employee_payable_total"
                        :min="0"
                        :precision="2"
                        :step="100"
                        :controls="false"
                        class="dispatch-center__fee-input"
                    />
                </el-form-item>
                <el-form-item :label="dispatchFeeDialogPaidLabel">
                    <el-input-number
                        v-model="feeForm.employee_paid_total"
                        :min="0"
                        :precision="2"
                        :step="100"
                        :controls="false"
                        class="dispatch-center__fee-input"
                    />
                </el-form-item>
                <el-form-item :label="dispatchFeeDialogPendingLabel">
                    <el-input
                        :value="feePendingDisplay"
                        disabled
                        class="dispatch-center__fee-input dispatch-center__fee-readonly dispatch-center__fee-pending"
                    />
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button type="primary" :loading="feeSaving" @click="submitDispatchFees">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import SettingsDispatchReceivers from './SettingsDispatchReceivers.vue';

export default {
    name: 'DispatchManagePage',
    components: {
        SettingsDispatchReceivers: SettingsDispatchReceivers
    },
    data: function () {
        return {
            activeTab: 'orders',
            ordersLoading: false,
            orders: [],
            orderPage: 1,
            orderPerPage: 10,
            orderFilters: {
                keyword: '',
                receiver_user_id: '',
                is_archived: '',
                settlement_status: ''
            },
            receiverOptions: [],
            orderStats: {
                order_count: 0,
                dispatch_payable_sum: 0,
                dispatch_paid_sum: 0,
                dispatch_pending_sum: 0
            },
            feeDialogVisible: false,
            feeSaving: false,
            actionSubmittingId: null,
            exportLoading: false,
            exportDateRange: [],
            feeForm: {
                order_id: null,
                employee_payable_total: 0,
                employee_paid_total: 0
            }
        };
    },
    computed: {
        canDeleteDispatchOrder: function () {
            var u = this.$store.getters.currentUser;
            if (u && u.is_super_admin) {
                return true;
            }
            var perms = u && u.permissions ? u.permissions : [];
            return perms.indexOf('order.delete') >= 0 || perms.indexOf('order.edit') >= 0;
        },
        /** 外派订单页：外派员子账号仅有 dispatch.receive 时也应显示「删除」 */
        showDispatchOrderDelete: function () {
            if (this.canDeleteDispatchOrder) {
                return true;
            }
            var u = this.$store.getters.currentUser;
            if (!u || u.is_super_admin) {
                return false;
            }
            var perms = u.permissions || [];
            return perms.indexOf('dispatch.receive') >= 0;
        },
        /** 与「外勤中心」一致：非超级管理员视为子账号，金额文案用「收」侧表述 */
        isDispatchSubaccount: function () {
            var u = this.$store.getters.currentUser;
            return !!(u && !u.is_super_admin);
        },
        isDispatchSuperAdmin: function () {
            var u = this.$store.getters.currentUser;
            return !!(u && u.is_super_admin);
        },
        /** 子账号仅看本人外派订单，无需按外派员筛选 */
        showDispatchReceiverFilter: function () {
            return !this.isDispatchSubaccount;
        },
        /** 仅税务外派专员子账号：独立列头展示 */
        isDispatchTaxOnlySubaccount: function () {
            if (!this.isDispatchSubaccount) {
                return false;
            }
            var u = this.$store.getters.currentUser || {};
            var roleCodes = this.currentUserRoleCodes();
            var byRole = roleCodes.indexOf('dispatch-specialist-tax') >= 0
                && roleCodes.indexOf('dispatch-specialist-biz') < 0
                && roleCodes.indexOf('dispatch-specialist-both') < 0;
            var menu = u.dispatch_receiver_menu || null;
            var byMenu = !!(menu && typeof menu === 'object' && menu.tax_stages === true && menu.biz_stages === false);
            return byRole || byMenu;
        },
        /** 仅工商外派专员子账号：确认收款逻辑对齐外勤专员 */
        isDispatchBizOnlySubaccount: function () {
            if (!this.isDispatchSubaccount) {
                return false;
            }
            var u = this.$store.getters.currentUser || {};
            var roleCodes = this.currentUserRoleCodes();
            var byRole = roleCodes.indexOf('dispatch-specialist-biz') >= 0
                && roleCodes.indexOf('dispatch-specialist-tax') < 0
                && roleCodes.indexOf('dispatch-specialist-both') < 0;
            var perms = Array.isArray(u.permissions) ? u.permissions : [];
            var byPermission = perms.indexOf('dispatch.receive') >= 0
                && perms.indexOf('biz.edit') >= 0
                && perms.indexOf('tax.edit') < 0;
            var menu = u.dispatch_receiver_menu || null;
            var byMenu = !!(menu && typeof menu === 'object' && menu.biz_stages === true && menu.tax_stages === false);
            return byRole || byPermission || byMenu;
        },
        isDispatchBothSubaccount: function () {
            if (!this.isDispatchSubaccount) {
                return false;
            }
            var u = this.$store.getters.currentUser || {};
            var roleCodes = this.currentUserRoleCodes();
            var byRole = roleCodes.indexOf('dispatch-specialist-both') >= 0;
            var menu = u.dispatch_receiver_menu || null;
            var byMenu = !!(menu && typeof menu === 'object' && menu.biz_stages === true && menu.tax_stages === true);
            return byRole || byMenu;
        },
        isDispatchBizOrBothSubaccount: function () {
            return this.isDispatchBizOnlySubaccount || this.isDispatchBothSubaccount;
        },
        dispatchStatPayableSumLabel: function () {
            return this.isDispatchSubaccount ? '应收合计' : '应付合计';
        },
        dispatchStatPaidSumLabel: function () {
            return this.isDispatchSubaccount ? '已收合计' : '已付合计';
        },
        dispatchStatPendingSumLabel: function () {
            return this.isDispatchSubaccount ? '待收合计' : '待付合计';
        },
        dispatchAmountPayableColLabel: function () {
            return this.isDispatchSubaccount ? '应收' : '应付';
        },
        dispatchAmountPaidColLabel: function () {
            return this.isDispatchSubaccount ? '已收' : '已付';
        },
        dispatchAmountPendingColLabel: function () {
            return this.isDispatchSubaccount ? '待收' : '待付';
        },
        dispatchFeeDialogPayableLabel: function () {
            return this.isDispatchSubaccount ? '应收外派' : '应付外派';
        },
        dispatchFeeDialogPaidLabel: function () {
            return this.isDispatchSubaccount ? '已收外派' : '已付外派';
        },
        dispatchFeeDialogPendingLabel: function () {
            return this.isDispatchSubaccount ? '待收外派' : '待付外派';
        },
        filteredOrders: function () {
            var _this = this;
            return (this.orders || []).filter(function (row) {
                if (_this.orderFilters.receiver_user_id !== '' && _this.orderFilters.receiver_user_id != null) {
                    var rid = Number(_this.orderFilters.receiver_user_id);
                    var rowRid = Number(row && row.dispatch ? row.dispatch.receiver_user_id : 0);
                    if (rid > 0 && rid !== rowRid) {
                        return false;
                    }
                }
                if ((_this.isDispatchSuperAdmin || _this.isDispatchBizOrBothSubaccount) && _this.orderFilters.settlement_status) {
                    var settled = _this.isDispatchOrderSettled(row);
                    if (_this.orderFilters.settlement_status === 'settled' && !settled) {
                        return false;
                    }
                    if (_this.orderFilters.settlement_status === 'unsettled' && settled) {
                        return false;
                    }
                }
                return true;
            });
        },
        feePendingDisplay: function () {
            var a = Number(this.feeForm.employee_payable_total || 0);
            var b = Number(this.feeForm.employee_paid_total || 0);
            return this.formatMoney(Math.max(0, a - b));
        },
        pagedOrders: function () {
            var start = (this.orderPage - 1) * this.orderPerPage;
            return this.filteredOrders.slice(start, start + this.orderPerPage);
        },
        shouldShowPager: function () {
            // 仅税务/仅工商外派专员：即使无数据也展示分页控件（共0条 + 页码 + 每页条数）。
            if (this.isDispatchTaxOnlySubaccount || this.isDispatchBizOrBothSubaccount) {
                return true;
            }
            return this.filteredOrders.length > 0;
        }
    },
    created: function () {
        if (this.isDispatchSubaccount) {
            this.orderFilters.receiver_user_id = '';
        } else {
            this.fetchReceiverOptions();
        }
        this.fetchOrders();
    },
    watch: {
        filteredOrders: function () {
            this.computeOrderStats();
            var last = Math.max(1, Math.ceil(this.filteredOrders.length / this.orderPerPage) || 1);
            if (this.orderPage > last) {
                this.orderPage = last;
            }
        }
    },
    methods: {
        currentUserRoleCodes: function () {
            var u = this.$store.getters.currentUser || {};
            var roles = u.roles || [];
            if (!Array.isArray(roles)) {
                return [];
            }
            var codes = [];
            for (var i = 0; i < roles.length; i++) {
                var role = roles[i];
                if (!role) {
                    continue;
                }
                if (typeof role === 'string') {
                    codes.push(role);
                    continue;
                }
                if (role.code) {
                    codes.push(String(role.code));
                }
            }
            return codes;
        },
        formatMoney: function (v) {
            var n = Number(v);
            if (!Number.isFinite(n)) {
                n = 0;
            }
            return n.toFixed(2);
        },
        receiverOptionLabel: function (u) {
            if (!u) {
                return '';
            }
            var name = u.name ? String(u.name).trim() : '';
            var username = u.username ? String(u.username).trim() : '';
            var displayName = name || username;
            var roleType = this.receiverRoleTypeLabel(u);

            if (!displayName) {
                return 'ID ' + u.id;
            }
            if (roleType) {
                return displayName + '-' + roleType;
            }
            return displayName;
        },
        receiverRoleTypeLabel: function (u) {
            var roles = u && Array.isArray(u.roles) ? u.roles : [];
            var roleCodes = [];
            for (var i = 0; i < roles.length; i++) {
                var role = roles[i];
                if (!role) {
                    continue;
                }
                if (typeof role === 'string') {
                    roleCodes.push(role);
                    continue;
                }
                if (role.code) {
                    roleCodes.push(String(role.code));
                }
            }

            if (roleCodes.indexOf('dispatch-specialist-both') >= 0) {
                return '税务+工商';
            }
            if (roleCodes.indexOf('dispatch-specialist-tax') >= 0 && roleCodes.indexOf('dispatch-specialist-biz') >= 0) {
                return '税务+工商';
            }
            if (roleCodes.indexOf('dispatch-specialist-tax') >= 0) {
                return '仅税务';
            }
            if (roleCodes.indexOf('dispatch-specialist-biz') >= 0) {
                return '仅工商';
            }
            return '';
        },
        formatOrderDate: function (row) {
            if (!row) {
                return '—';
            }
            var d = row.receipt_date;
            if (d && typeof d === 'string') {
                return d.length >= 10 ? d.slice(0, 10) : d;
            }
            if (row.created_at) {
                var s = String(row.created_at);
                return s.length >= 10 ? s.slice(0, 10) : s;
            }
            return '—';
        },
        fetchReceiverOptions: function () {
            var _this = this;
            window.axios.get('/dispatch/receivers', { params: { for_dispatch_order_filter: 1 } }).then(function (res) {
                _this.receiverOptions = (res.data && res.data.data) || [];
            }).catch(function () {
                _this.receiverOptions = [];
            });
        },
        fetchOrders: function () {
            var _this = this;
            this.ordersLoading = true;
            var params = {
                is_dispatched: 1
            };
            // 仅税务外派专员：该页用于查看其「已清税」完成单
            if (this.isDispatchTaxOnlySubaccount) {
                params.tax_cleared = 1;
            }
            if (this.orderFilters.keyword) {
                params.keyword = this.orderFilters.keyword;
            }
            if (this.orderFilters.is_archived !== '' && this.orderFilters.is_archived !== null) {
                params.is_archived = this.orderFilters.is_archived;
            }
            if (this.isDispatchSuperAdmin || this.isDispatchBizOrBothSubaccount) {
                delete params.is_archived;
            }
            window.axios.get('/orders', { params: params }).then(function (res) {
                _this.orders = (res.data && res.data.data) || [];
                _this.orderPage = 1;
                _this.computeOrderStats();
            }).catch(function () {
                _this.$message.error('加载外派订单失败');
                _this.orders = [];
                _this.computeOrderStats();
            }).finally(function () {
                _this.ordersLoading = false;
            });
        },
        runOrderSearch: function () {
            this.fetchOrders();
        },
        resetOrderFilters: function () {
            this.orderFilters = {
                keyword: '',
                receiver_user_id: '',
                is_archived: '',
                settlement_status: ''
            };
            this.fetchOrders();
        },
        isDispatchOrderSettled: function (row) {
            var d = row && row.dispatch ? row.dispatch : null;
            if (!d) {
                return false;
            }
            var payable = Number(d.employee_payable_total != null ? d.employee_payable_total : (d.dispatch_amount || 0));
            var pending = this.dispatchPendingAmount(row);
            if (payable === 0 || pending > 0) {
                return false;
            }
            // 外派专员（仅工商 / 税工）：结清需额外满足已点击「确认收款」
            if (this.isDispatchBizOrBothSubaccount) {
                return this.isDispatchReceiptConfirmed(row);
            }
            return true;
        },
        exportTaxOnlyOrders: function () {
            var _this = this;
            if (!this.isDispatchTaxOnlySubaccount) {
                return;
            }
            if (!this.exportDateRange || this.exportDateRange.length !== 2) {
                this.$message.warning('请先选择导出日期范围');
                return;
            }

            this.exportLoading = true;
            window.axios.get('/dispatch/orders/export', {
                params: {
                    keyword: this.orderFilters.keyword || '',
                    start_date: this.exportDateRange[0],
                    end_date: this.exportDateRange[1]
                },
                responseType: 'blob'
            }).then(function (response) {
                var blobUrl = window.URL.createObjectURL(new Blob([response.data]));
                var link = document.createElement('a');
                link.href = blobUrl;
                link.download = '已完成订单导出-' + Date.now() + '.csv';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
                _this.$message.success('导出成功');
            }).catch(function (error) {
                var msg = error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : '导出失败';
                _this.$message.error(msg);
            }).finally(function () {
                _this.exportLoading = false;
            });
        },
        openDispatchFee: function (row) {
            if (!row || !row.id) {
                return;
            }
            var d = row.dispatch || {};
            this.feeForm = {
                order_id: row.id,
                employee_payable_total: d.employee_payable_total != null ? Number(d.employee_payable_total) : Number(d.dispatch_amount || 0),
                employee_paid_total: d.employee_paid_total != null ? Number(d.employee_paid_total) : 0
            };
            this.feeDialogVisible = true;
        },
        dispatchPendingAmount: function (row) {
            var d = row && row.dispatch ? row.dispatch : null;
            if (!d) {
                return 0;
            }
            if (d.employee_pending_total != null && Number.isFinite(Number(d.employee_pending_total))) {
                return Math.max(0, Number(d.employee_pending_total));
            }
            var payable = Number(d.employee_payable_total != null ? d.employee_payable_total : (d.dispatch_amount || 0));
            var paid = Number(d.employee_paid_total || 0);
            return Math.max(0, payable - paid);
        },
        isDispatchFeeLocked: function (row) {
            if (!this.isDispatchSuperAdmin) {
                return false;
            }
            var d = row && row.dispatch ? row.dispatch : null;
            if (!d) {
                return false;
            }
            var payable = Number(d.employee_payable_total != null ? d.employee_payable_total : (d.dispatch_amount || 0));
            return payable !== 0 && this.dispatchPendingAmount(row) <= 0;
        },
        dispatchFeeActionClass: function (row) {
            if (this.isDispatchFeeLocked(row)) {
                return 'dispatch-center__fee-action-locked';
            }
            return '';
        },
        isDispatchReceiptConfirmed: function (row) {
            var d = row && row.dispatch ? row.dispatch : null;
            return !!(d && d.employee_receipt_confirmed_at);
        },
        isDispatchConfirmSettled: function (row) {
            var d = row && row.dispatch ? row.dispatch : null;
            if (!d) {
                return false;
            }
            var payable = Number(d.employee_payable_total != null ? d.employee_payable_total : (d.dispatch_amount || 0));
            return payable !== 0 && this.dispatchPendingAmount(row) <= 0 && this.isDispatchReceiptConfirmed(row);
        },
        dispatchConfirmActionClass: function (row) {
            return this.isDispatchConfirmSettled(row) ? 'dispatch-center__confirm-action-done' : '';
        },
        canConfirmDispatchCollection: function (row) {
            if (!this.isDispatchBizOrBothSubaccount || !row) {
                return false;
            }
            if (this.isDispatchReceiptConfirmed(row)) {
                return false;
            }
            var d = row && row.dispatch ? row.dispatch : null;
            var payable = Number(d && d.employee_payable_total != null ? d.employee_payable_total : (d && d.dispatch_amount ? d.dispatch_amount : 0));
            if (payable === 0) {
                return false;
            }
            return this.dispatchPendingAmount(row) <= 0;
        },
        canRemindDispatchCollection: function (row) {
            if (!this.isDispatchBizOrBothSubaccount || !row) {
                return false;
            }
            if (this.isDispatchReceiptConfirmed(row)) {
                return false;
            }
            if (this.dispatchPendingAmount(row) <= 0) {
                return false;
            }
            if (Number(row.tax_progress_status || 0) !== 4) {
                return false;
            }
            var isBizDone = Number(row.biz_progress_status || 0) === 103
                || this.isOrderExternalRegDeregistered(row.external_reg_status)
                || Number(row.is_archived) === 1;
            if (!isBizDone) {
                return false;
            }
            var base = row.external_reg_checked_at || row.updated_at || row.created_at;
            if (!base) {
                return false;
            }
            var ms = new Date(base).getTime();
            if (!Number.isFinite(ms)) {
                return false;
            }
            return (Date.now() - ms) >= (3 * 24 * 60 * 60 * 1000);
        },
        confirmDispatchReceipt: function (row) {
            var _this = this;
            if (!this.isDispatchBizOrBothSubaccount) {
                return;
            }
            if (!row || !row.id || !this.canConfirmDispatchCollection(row) || this.actionSubmittingId) {
                return;
            }
            this.actionSubmittingId = row.id;
            window.axios.post('/orders/' + row.id + '/dispatch-confirm-receipt').then(function (res) {
                _this.$message.success((res.data && res.data.message) || '确认收款成功');
                _this.fetchOrders();
            }).catch(function (err) {
                var msg = err && err.response && err.response.data && err.response.data.message
                    ? err.response.data.message
                    : '确认收款失败';
                _this.$message.error(msg);
            }).finally(function () {
                _this.actionSubmittingId = null;
            });
        },
        remindDispatchCollection: function (row) {
            var _this = this;
            if (!row || !row.id || !this.canRemindDispatchCollection(row) || this.actionSubmittingId) {
                return;
            }
            this.actionSubmittingId = row.id;
            window.axios.post('/orders/' + row.id + '/dispatch-remind-collection').then(function (res) {
                _this.$message.success((res.data && res.data.message) || '催款提醒已发送');
                _this.fetchOrders();
            }).catch(function (err) {
                var msg = err && err.response && err.response.data && err.response.data.message
                    ? err.response.data.message
                    : '催款失败';
                _this.$message.error(msg);
            }).finally(function () {
                _this.actionSubmittingId = null;
            });
        },
        resetFeeForm: function () {
            this.feeForm = {
                order_id: null,
                employee_payable_total: 0,
                employee_paid_total: 0
            };
            this.feeSaving = false;
        },
        submitDispatchFees: function () {
            var _this = this;
            if (!this.feeForm.order_id) {
                return;
            }
            var payable = Number(this.feeForm.employee_payable_total || 0);
            var paid = Number(this.feeForm.employee_paid_total || 0);
            if (paid > payable) {
                this.$message.warning(
                    this.isDispatchSubaccount ? '已收外派不能大于应收外派' : '已付外派不能大于应付外派'
                );
                return;
            }

            this.feeSaving = true;
            window.axios.put('/orders/' + this.feeForm.order_id + '/dispatch/fees', {
                employee_payable_total: payable,
                employee_paid_total: paid
            }).then(function (res) {
                _this.$message.success((res.data && res.data.message) || '外派费用已保存');
                _this.feeDialogVisible = false;
                _this.fetchOrders();
            }).catch(function (err) {
                var msg = err && err.response && err.response.data && err.response.data.message
                    ? err.response.data.message
                    : '保存失败';
                _this.$message.error(msg);
            }).finally(function () {
                _this.feeSaving = false;
            });
        },
        confirmDeleteOrder: function (row) {
            var _this = this;
            if (this.isDispatchBizOrBothSubaccount) {
                return;
            }
            if (!row || !row.id) {
                return;
            }
            this.$confirm('确认删除该订单吗？删除后将不可恢复。', '提示', {
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                return window.axios.delete('/orders/' + row.id);
            }).then(function (res) {
                _this.$message.success(res.data && res.data.message ? res.data.message : '删除成功');
                _this.fetchOrders();
            }).catch(function (err) {
                if (err === 'cancel' || err === 'close') {
                    return;
                }
                var msg = err && err.response && err.response.data && err.response.data.message
                    ? err.response.data.message
                    : '删除失败';
                _this.$message.error(msg);
            });
        },
        handleOrderPageChange: function (p) {
            this.orderPage = p;
        },
        handleOrderPageSizeChange: function (size) {
            this.orderPerPage = size;
            this.orderPage = 1;
        },
        dispatchReceiverName: function (row) {
            var receiver = row && row.dispatch && row.dispatch.receiver ? row.dispatch.receiver : null;
            if (!receiver) {
                return '—';
            }
            return receiver.name || receiver.username || '—';
        },
        dispatchReceiverPhone: function (row) {
            var receiver = row && row.dispatch && row.dispatch.receiver ? row.dispatch.receiver : null;
            return receiver && receiver.phone ? receiver.phone : '—';
        },
        formatTaxProgressLabel: function (row) {
            var n = row && row.tax_progress_status != null ? Number(row.tax_progress_status) : null;
            if (n === null || Number.isNaN(n)) {
                return '—';
            }
            var map = { 1: '税务未开', 3: '清税中', 4: '已清税' };
            return map[n] || '—';
        },
        formatBizProgressLabel: function (row) {
            if (!row) {
                return '—';
            }
            if (Number(row.biz_progress_status || 0) === 104) {
                return '已驳回';
            }
            if (Number(row.tax_progress_status || 0) !== 4) {
                return '—';
            }
            if (this.isOrderExternalRegDeregistered(row.external_reg_status) || Number(row.is_archived) === 1) {
                return '已注销';
            }
            var map = { 101: '办理中', 102: '公示中', 103: '待提交', 104: '异常' };
            var n = Number(row.biz_progress_status || 0);
            return map[n] || '—';
        },
        formatTaxAccountStatusLabel: function (status) {
            var n = Number(status || 0);
            var map = {
                1: '正常户',
                2: '非正常户'
            };
            return map[n] || '—';
        },
        isOrderExternalRegDeregistered: function (statusText) {
            if (statusText === null || statusText === undefined) {
                return false;
            }
            return String(statusText).indexOf('注销') !== -1;
        },
        dispatchFee: function (row, part) {
            var d = row && row.dispatch ? row.dispatch : null;
            if (!d) {
                return this.formatMoney(0);
            }
            var payable = Number(d.employee_payable_total != null ? d.employee_payable_total : (d.dispatch_amount || 0));
            var paid = Number(d.employee_paid_total || 0);
            var pending = Number(d.employee_pending_total != null ? d.employee_pending_total : Math.max(0, payable - paid));
            if (part === 'payable') {
                return this.formatMoney(payable);
            }
            if (part === 'paid') {
                return this.formatMoney(paid);
            }
            return this.formatMoney(Math.max(0, pending));
        },
        computeOrderStats: function () {
            var list = this.filteredOrders || [];
            var payable = 0;
            var paid = 0;
            var pending = 0;
            for (var i = 0; i < list.length; i++) {
                var d = list[i] && list[i].dispatch ? list[i].dispatch : null;
                var p1 = Number(d && d.employee_payable_total != null ? d.employee_payable_total : (d && d.dispatch_amount ? d.dispatch_amount : 0));
                var p2 = Number(d && d.employee_paid_total ? d.employee_paid_total : 0);
                var p3 = Number(d && d.employee_pending_total != null ? d.employee_pending_total : Math.max(0, p1 - p2));
                payable += Number.isFinite(p1) ? p1 : 0;
                paid += Number.isFinite(p2) ? p2 : 0;
                pending += Number.isFinite(p3) ? p3 : 0;
            }
            this.orderStats = {
                order_count: list.length,
                dispatch_payable_sum: Number(payable.toFixed(2)),
                dispatch_paid_sum: Number(paid.toFixed(2)),
                dispatch_pending_sum: Number(pending.toFixed(2))
            };
        }
    }
};
</script>

<style scoped>
.dispatch-center__tabs /deep/ .el-tabs__header {
    display: none;
}

.dispatch-center__shell {
    margin-top: 8px;
}

.dispatch-center__pane {
    min-height: 200px;
}

.dispatch-center__filter-input--wide {
    width: 260px;
}

.dispatch-center__filter-select {
    width: 200px;
}

.dispatch-center__filter-select--narrow {
    width: 120px;
}

.dispatch-center__filters-actions-inline {
    margin-left: 6px;
    display: flex;
    align-items: center;
    gap: 8px;
    padding-bottom: 18px;
}

.dispatch-center__export-inline {
    display: flex;
    align-items: center;
    gap: 8px;
}

.dispatch-center__export-date {
    width: 250px;
}

.dispatch-center__table.app-hub-table {
    width: auto;
    max-width: 100%;
}

.dispatch-center__delete {
    color: #f56c6c;
}

.dispatch-center__fee-action-locked.el-button--text,
.dispatch-center__fee-action-locked.el-button--text.is-disabled {
    color: #67c23a !important;
    -webkit-text-fill-color: #67c23a;
    cursor: not-allowed !important;
}

.dispatch-center__confirm-action-done.el-button--text,
.dispatch-center__confirm-action-done.el-button--text.is-disabled {
    color: #67c23a !important;
    -webkit-text-fill-color: #67c23a;
    cursor: not-allowed !important;
}

.dispatch-center__fee-input {
    width: 100%;
}

.dispatch-center__fee-readonly >>> .el-input__inner {
    text-align: center;
    font-weight: 500;
}

.dispatch-center__fee-pending.dispatch-center__fee-readonly.is-disabled >>> .el-input__inner {
    color: #909399;
    -webkit-text-fill-color: #909399;
    cursor: not-allowed;
}

/* 外派员手机号：显式关闭列级省略提示，并换行展示，避免 Element 表格共享 tooltip 误判溢出 */
.dispatch-center__table /deep/ td.dispatch-center__td-phone .cell {
    white-space: normal;
    word-break: break-all;
    line-height: 1.35;
}

.dispatch-center__table /deep/ td.dispatch-center__td-phone .dispatch-center__phone-text {
    display: inline-block;
    max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/DispatchManagePage.vue